import styled, { keyframes } from 'styled-components';
import React from 'react';

// Shimmer animation
const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

// Skeleton container
export const SkeletionContainer = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin: 0 auto;
  padding-top: 4rem;
  width: 90%;
  min-height: 100vh;
`;

// Base skeleton style with shimmer effect
const SkeletonBase = styled.div`
  background: linear-gradient(
    90deg,
    rgba(224, 224, 224, 0.8) 25%,
    rgba(240, 240, 240, 0.9) 50%,
    rgba(224, 224, 224, 0.8) 75%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s infinite;
  border-radius: ${({ theme }) => theme.borderRadius || '6px'};
`;

// Header styles
const SkeletonHeader = styled(SkeletonBase)`
  width: 90%;
  height: 30px;
  margin-bottom: 2rem;
`;

const YellowUnderline = styled.div`
  width: 90%;
  height: 5px;
  background-color: ${({ theme }) => theme.colors.yellow3 || '#ffcc00'};
  margin-bottom: 20px;
`;

// Subheading styles
const SkeletonSubheading = styled(SkeletonBase)`
  width: 90%;
  height: 20px;
  margin-bottom: 3rem;
`;

// Label and input container
const SkeletonLabelInputContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 90%;
  margin-bottom: 2rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey};
`;

const SkeletonLabel = styled(SkeletonBase)`
  width: 20%;
  height: 16px;
`;

const SkeletonInput = styled(SkeletonBase)`
  width: 60%;
  height: 40px;
`;

// Button styles
const SkeletonButton = styled(SkeletonBase)`
  width: 200px;
  height: 40px;
  margin-top: 20px;
`;

const FormLoading = () => {
  return (
    <SkeletionContainer>
      <SkeletonHeader />
      <YellowUnderline />
      <SkeletonLabelInputContainer>
        <SkeletonLabel />
        <SkeletonInput />
      </SkeletonLabelInputContainer>
      <SkeletonLabelInputContainer>
        <SkeletonLabel />
        <SkeletonInput />
      </SkeletonLabelInputContainer>
      <SkeletonLabelInputContainer>
        <SkeletonLabel />
        <SkeletonInput />
      </SkeletonLabelInputContainer>
      <SkeletonLabelInputContainer>
        <SkeletonLabel />
        <SkeletonInput />
      </SkeletonLabelInputContainer>
      <SkeletonSubheading />
      <SkeletonLabelInputContainer>
        <SkeletonLabel />
        <SkeletonInput />
      </SkeletonLabelInputContainer>
      <SkeletonLabelInputContainer>
        <SkeletonLabel />
        <SkeletonInput />
      </SkeletonLabelInputContainer>
      <SkeletonLabelInputContainer>
        <SkeletonLabel />
        <SkeletonInput />
      </SkeletonLabelInputContainer>
      <SkeletonLabelInputContainer>
        <SkeletonLabel />
        <SkeletonInput />
      </SkeletonLabelInputContainer>
      {/* Button */}
      <SkeletonButton />
    </SkeletionContainer>
  );
};

export default FormLoading;
